import React from "react";
import { Row, Col, Statistic, Icon } from "antd";
import { useTranslation } from 'react-i18next'
import { marksAgitation } from "../../constants";
import { FigureInfomationWrapper } from "./styles";
import { secons2Dhm } from "../../services/timeFunctions";
import colors from "../../theme/colors";
const RenderDesingProcessData = ({ selectedProcessDesing, setModal,isFisrt }) => {
  const { t } = useTranslation();
  if (!selectedProcessDesing) return null;
  return (
    <FigureInfomationWrapper>
      <Row style={{ margin: 0 }} gutter={[16, 16]}>
        {/*CALENTAMIENTO*/}
        <Col span={8}>
          <h3>{t('phase.warm_up')}</h3>
          {/*TEMPERATURA*/}
          <Col span={24} style={{marginTop:15}}>
            <Statistic
              title={t("labels.temperature")}
              value={selectedProcessDesing && selectedProcessDesing.furnace && selectedProcessDesing.furnace.temperature}
              suffix="ºC"
            />
          </Col>
          {/*RAMPRA*/}
          <Col span={24} style={{marginTop:15}}>
            <Statistic
               title={t("labels.ramp")}
               value={
                 selectedProcessDesing && selectedProcessDesing.furnace && selectedProcessDesing.furnace.heating_ramp === 5000
                   ? t("labels.no_ramp")
                   : selectedProcessDesing.furnace.heating_ramp
               }
               suffix={
                 selectedProcessDesing && selectedProcessDesing.furnace && selectedProcessDesing.furnace.heating_ramp === 5000 ? "" : "ºC/h"
               } 
            />
          </Col>
          {/*TEMPERATURA PIEZA*/}
          <Col span={24} style={{marginTop:15}}>
            <Statistic
              title={t("labels.temperature_piece")}
              value={selectedProcessDesing && selectedProcessDesing.furnace && selectedProcessDesing.furnace.piece_temperrature}
              suffix="ºC"
            />
          </Col>
          {/*TIEMPO*/}
          <Col span={24} style={{marginTop:15}}>
            <Statistic
              title={t("labels.time_d_hh_mm")}
              value={
                selectedProcessDesing &&
                selectedProcessDesing.recommendation &&
                selectedProcessDesing.recommendation.furnace_time &&
                secons2Dhm(selectedProcessDesing.recommendation.furnace_time)
              }
            />
          </Col>
        </Col>

        {/*FORJA*/}
        <Col span={8}>
          <h3>{t('phase.forja')}</h3>
          {/*Nº DE PASADAS*/}
          <Col span={24} style={{marginTop:15}}>
            <Statistic
              title={t("phase.nPasadas")}
              value={selectedProcessDesing && selectedProcessDesing.forja && selectedProcessDesing.forja.nPasadas.valor}
              suffix={selectedProcessDesing && selectedProcessDesing.forja && selectedProcessDesing.forja.nPasadas.suf}
            />
          </Col>
          {/*ALTURA INICIAL*/}
          <Col span={24} style={{marginTop:15}}>
            <Statistic
              title={t("phase.AltI")}
              value={selectedProcessDesing && selectedProcessDesing.forja && selectedProcessDesing.forja.AltI.valor}
              suffix={selectedProcessDesing && selectedProcessDesing.forja && selectedProcessDesing.forja.AltI.suf}
            />
          </Col>
          {/*ALTURA FINAL*/}
          <Col span={24} style={{marginTop:15}}>
            <Statistic
              title={t("phase.AltF")}
              value={selectedProcessDesing && selectedProcessDesing.forja && selectedProcessDesing.forja.AltF.valor}
              suffix={selectedProcessDesing && selectedProcessDesing.forja && selectedProcessDesing.forja.AltF.suf}
            />
          </Col>
          {/*BOTON VER MAS*/}
          {isFisrt&&
            <Col span={24} style={{marginTop:15,cursor: "pointer"}}>
              <span onClick={() => setModal()}>
                <Icon type="eye" key="eye" /> {t('button.more_info')}
              </span>
            </Col>
          }
        </Col>

        {/*ENFRIAMIENTO*/}
        <Col span={8}>
          <h3>{t('phase.warm_down')}</h3>
           {/*MEDIO*/}
           <Col span={24} style={{marginTop:15}}>
            <Statistic
              title={t("phase.medio")}
              value={selectedProcessDesing && selectedProcessDesing.quenching && t("phase."+selectedProcessDesing.quenching.medio)}
              suffix=""
            />
          </Col>
          {/*TEMPERATURA*/}
          <Col span={24} style={{marginTop:15}}>
            <Statistic
              title={t("labels.temperature")}
              value={selectedProcessDesing && selectedProcessDesing.quenching && selectedProcessDesing.quenching.bath_temperature}
              suffix="ºC"
            />
          </Col>
          {/*AGITACION*/}
          <Col span={24} style={{marginTop:15}}>
            <Statistic
              title={t("labels.agitation")}
              value={
                selectedProcessDesing && selectedProcessDesing.quenching && marksAgitation[selectedProcessDesing.quenching.agitation_level]
              }
              suffix={selectedProcessDesing.quenching.agitation_level === 0 ? "" : "m/s"}
            />
          </Col>
        </Col>
      </Row>
    </FigureInfomationWrapper>
  );
};

export default RenderDesingProcessData;
